module.exports = __webpack_public_path__ + "img/tune-up-banner.0a6b8052.png";